// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import AuditClaim from '@deere/cps-it.warranty-model-factory/lib/audit-claim';
import AuditClaimListItem from '../../shared/components/audit-claim-list-item';
import {FormattedMessage} from 'react-intl';

const ClaimResult = props =>
    <AuditClaimListItem item={props.item}>
        <footer>
            {props.isClaimInAudit ?
                <button onClick={props.handleRemoveClaim}>
                    <FormattedMessage id='REMOVE_FROM_AUDIT'/>
                </button> :
                <button
                    className='button-primary'
                    onClick={props.handleAddClaim}
                >
                    <FormattedMessage id='ADD_TO_AUDIT'/>
                </button>
            }
        </footer>
    </AuditClaimListItem>;

ClaimResult.displayName = 'ClaimResult';
ClaimResult.propTypes = {
    handleAddClaim: PropTypes.func.isRequired,
    handleRemoveClaim: PropTypes.func.isRequired,
    isClaimInAudit: PropTypes.bool.isRequired,
    item: PropTypes.instanceOf(AuditClaim).isRequired
};

export default ClaimResult;



// WEBPACK FOOTER //
// ./src/tcsm/claim-search/components/claim-result.js